import { Trans } from "react-i18next"

export default function UnlockedAchievementContent({ events }) {
  const achievement = events.map((e, index) => (index !== 0 ? " " : "") + e.achievement).join("")

  return <Trans i18nKey="notifications.unlockedAchievement" values={{ achievement }} components={{ b: <b /> }} />
}
